import { useParams } from 'react-router-dom';
import { useAtomValue } from 'jotai';
import T from '@wojtekmaj/react-t';

import {
  ContentWrapper,
  Image,
  ImageAndContentWrapper,
  Link,
  Name,
  NameWrapper,
} from './index.styles';

import PlaceLikeButton from '../../../../../../common/place_like_button';
import PageWrapper from '../../../../../../page_wrapper';
import HeaderWithButton from '../../../../header_with_button';
import PlaceInfo from './place_info';
import Products from './products';

import useI18nText from '../../../../../../../hooks/useI18nText';

import { vendorBusinessState, vendorPlaceQuery } from '../../../../../../../store';

import type { Place } from '@rewardopl/types';

export default function PlacePage() {
  const { place_id: placeId } = useParams<{ place_id?: Place['_id'] }>();

  if (!placeId) {
    throw new Error('placeId is undefined');
  }

  const place = useAtomValue(vendorPlaceQuery(placeId));

  const business = useAtomValue(vendorBusinessState);

  const placeWithDefaults = {
    ...business,
    ...place,
  };

  const { name, name_i18n: nameI18n, picture } = placeWithDefaults;

  const nameString = useI18nText(nameI18n, name);

  return (
    <PageWrapper withPadding={false}>
      <HeaderWithButton extraButton={<PlaceLikeButton placeId={place._id} showLabel={false} />}>
        Restaurants
      </HeaderWithButton>
      <ImageAndContentWrapper>
        {picture ? <Image alt={nameString} src={`/api/uploads/${picture}`} /> : null}
        <ContentWrapper>
          <NameWrapper>
            <Name>{nameString}</Name>
            <Link to={`/map/${placeId}`}>
              <T>See on a map</T>
            </Link>
            <PlaceInfo place={placeWithDefaults} />
          </NameWrapper>
          <Products placeId={placeId} />
        </ContentWrapper>
      </ImageAndContentWrapper>
    </PageWrapper>
  );
}
